/* eslint-disable no-lonely-if */
/* eslint-disable import/prefer-default-export */

import SessionService from '../services/SessionService';
import { CookieHelper } from './CookieHelper';
import { HostProvider } from './HostProvider';
import { StorageHelper } from './StorageHelper';

export class SessionChecker {
  static checkSession = async (
    view: string,
    lang: string,
    isApp: boolean,
    isRecuerdame?: boolean,
  ) => {
    if (!isApp && isRecuerdame !== undefined) {
      const response = await SessionService.checkSession(view);
      const { pojo } = response.data;
      if (response.data.error === false) {
        const renewedToken = pojo.token;
        if (renewedToken) {
          CookieHelper.renewToken(renewedToken, isRecuerdame);
        } else {
          if (pojo.login) {
            SessionChecker.closeSessionAndGoToLogin(view, lang);
          } else if (pojo.reLogin) {
            SessionChecker.closeSessionAndGoToReLogin(view, lang);
          } else if (pojo.needsRedirect) {
            document.location.href = `${HostProvider.getHost()}${lang}/${
              pojo.urRedirection
            }`;
          }
        }
        if (pojo.login || pojo.reLogin || pojo.needsRedirect) {
          return false;
        }
      } else {
        if (response.data.errorCode === 1) {
          SessionChecker.closeSessionAndGoToLogin(view, lang);
        } else {
          if (response.data.errorCode === 100) {
            SessionChecker.closeSessionAndGoToReLogin(view, lang);
          }
        }
        return false;
      }
      return true;
    }

    if (isApp) {
      return true;
    }
    return false;
  };

  static closeSessionAndGoToLogin = (view: string | null, lang: string) => {
    const origin = StorageHelper.getOrigin();
    const viewForBack = view && true && view !== 'null' ? view : origin;
    SessionChecker.closeSesion(origin);
    if (viewForBack) {
      document.location.href = `${HostProvider.getHost()}${lang}/logout?apToLogin=true&fromUrl=${viewForBack}`;
    } else {
      document.location.href = `${HostProvider.getHost()}${lang}/logout?apToLogin=true`;
    }
  };

  static closeSessionAndGoToReLogin = (view: string | null, lang: string) => {
    const origin = StorageHelper.getOrigin();
    const viewForBack = view && true && view !== 'null' ? view : origin;
    SessionChecker.closeSesion(origin);
    if (viewForBack) {
      document.location.href = `${HostProvider.getHost()}${lang}/logout?apToRelogin=true&fromUrl=${viewForBack}`;
    } else {
      document.location.href = `${HostProvider.getHost()}${lang}/logout?apToRelogin=true`;
    }
  };

  static closeSesion = (origin: string | null) => {
    StorageHelper.deleteUserFromSession();
    CookieHelper.removeUserCookiesForLogout();
    sessionStorage.clear();
    if (origin) {
      StorageHelper.setOrigin(origin);
    }
  };
}
